import React from 'react';

interface FullPdfViewerFallbackProps {
  pdfUrl: string;
}

/**
 * Fallback component for FullPDFViewer when the browser cannot parse modern JavaScript.
 * Displays a message with a link to download/view the PDF instead.
 */
export const FullPdfViewerFallback: React.FC<FullPdfViewerFallbackProps> = ({ pdfUrl }) => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[400px] border border-gray-300 rounded-lg bg-gray-50 p-8">
      <div className="text-center max-w-md">
        <p className="text-lg font-medium text-gray-700 mb-2">PDF viewer not available</p>
        <p className="text-sm text-gray-600 mb-6">
          Your browser version does not support PDF rendering. Please use a newer browser or download the PDF to view it.
        </p>
        <a
          href={pdfUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
        >
          Open PDF in new tab
        </a>
      </div>
    </div>
  );
};

export default FullPdfViewerFallback;

